<template>
  <div class="upload-main">
    <div class="upload-box" @click="onOpenFile">
      <img v-if="img" :src="img + '?r_upload=' + Math.random() * 1000" alt="avatar" width="126" />
      <div v-else class="upload-file">
        <loading-outlined v-if="loading"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
        <div class="ant-upload-text">{{ $t('_a._sctp') }}</div>
      </div>
    </div>
    <input ref="files" type="file" accept="image/*" @change="onFile" hidden />
  </div>
</template>

<script>
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    PlusOutlined,
    LoadingOutlined
  },
  emits: ['onUpload'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      img: ''
    }
  },
  created() {
    this.$watch('imageUrl', () => {
      this.img = this.imageUrl
      console.log(this.img, this.imageUrl)
    })
  },
  methods: {
    onOpenFile() {
      if (this.disabled) {
        return
      }
      this.$refs.files.click()
    },
    onFile(file) {
      const files = file.target.files[0]
      console.log(files)
      let uploadFile = new FormData()
      uploadFile.append('file', files)

      this.loading = true
      this.$api.tools.upload(uploadFile).then((res) => {
        this.loading = false
        this.img = res.data.path
        this.$emit('onUpload', res.data.path)
      })
    }
  }
}
</script>

<style>
.upload-main {
  display: flex;
}
.upload-box {
  cursor: pointer;
  width: auto;
  max-width: 300px;
  height: 100px;
  border: 1px #ccc dashed;
}

.upload-box img {
  /* width: 100%; */
  height: 100%;
}

.upload-file {
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
